import { z } from 'zod'
// Zod v4 probes eval availability on first ZodObject instantiation.
// Our CSP blocks eval — jitless disables the probe; non-eval parse path is used.
// No functional difference: this codebase uses zod only for API response validation.
z.config({ jitless: true })
